export default __webpack_public_path__ + "static/media/btn-arrow.65c50693.svg";